import React, { useEffect, useState, useRef, useCallback } from 'react';
import { View, Text, Pressable, StyleSheet, Icon2, Icon, Icon3 } from '../lib/react-native-compat';
import { useAtom } from 'jotai';
import { loadTeamUserData, loadCostDetailBillings, loadTeamCostDetail, loadTeamOpemCommitments, pNum, fNum, loadSummaryWIP, loadEquipmentData, loadTeamBillings, updateUserDataArray, loadSummaryWIPArray, loadOverheadData } from '../db/company';
import { dataSourceVersionAtom, isLiveVersionAtom, selectedVersionAtom, equipmentRatesAtom, selectedTeamAtom, dataSourceJobsAtom, overheadDataAtom, jobUserDataAtom, selectedWIPAtom, selectedVersionLockedAtom, projectCompleteAtom, ohPercentAtom } from '../store/company';
import moment from 'moment';
import xlsx from 'xlsx';
import { fieldBonusRemoved } from '../helpers/fieldBonus';
import AISummary from './AISummary';

const Summary = ({ photo, view, setJobRef, job, refSubNav, forceLoadAll, hideProgram, onSummaryData, onUserData, onCostDetailData, onCommitmentsData, onBillingsData }) => {
    const [versions, setVersions] = useAtom(dataSourceVersionAtom)
    const [versionCleaned, setVersionCleaned] = useState([])
    const [versionDropdown, setVersionDropdown] = useState([])
    const [versionInfo, setVersionInfo] = useState({})
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [selectedTeam, setSelectedTeam] = useAtom(selectedTeamAtom);
    const [jobs, setJobs] = useAtom(dataSourceJobsAtom);
    const [selectedWIP, setSelectedWIP] = useAtom(selectedWIPAtom);
    const [ohPercent, setOhPercent] = useAtom(ohPercentAtom)
    const [overheadData, setOverheadData] = useAtom(overheadDataAtom)
    const [lockedVersion, setLockedVersion] = useAtom(selectedVersionLockedAtom)
    const [jobUserData, setJobUserData] = useAtom(jobUserDataAtom)
    const [filteredJobs, setFilteredJobs] = useState([])
    const [curBudget, setCurBudget] = useState({})
    const [fetchedAllJobUserData, setFetchedAllJobUserData] = useState(false)
    const [startDates, setStartDates] = useState({})
    const [completionDates, setCompletionDates] = useState({})
    const [mechCompleteDates, setMechCompleteDates] = useState({})
    const [physicalComplete, setPhysicalComplete] = useState({})
    const [actualCost, setActualCost] = useState({})
    const [actualOverhead, setActualOverhead] = useState({})
    const [openCommitments, setOpenCommitments] = useState({})
    const [ETC, setETC] = useState({})
    const [EAC, setEAC] = useState({})
    const [jobProfit, setJobProfit] = useState({})
    const [jobProfitPerc, setJobProfitPerc] = useState({})
    const [jobPrevWIP, setJobPrevWIP] = useState({})
    //const [equipRates, setEquipRates] = useState({})
    const [equipmentUserData, setEquipmentUserData] = useState({})
    const [labor, setLabor] = useState({})
    const [equipmentCostType, setEquipmentCostType] = useState({})
    const [equipmentPhased, setEquipmentPhased] = useState({})
    const [materials, setMaterials] = useState({})
    const [rentals, setRentals] = useState({})
    const [subcontractors, setSubcontractors] = useState({})
    const [other, setOther] = useState({})
    const [contingency, setContingency] = useState({})
    const [incentive, setIncentive] = useState({})
    const [total, setTotal] = useState({})
    const [projectComplete, setProjectComplete] = useAtom(projectCompleteAtom)
    const [grossMargin, setGrossMargin] = useState({})
    const [grossMarginPerc, setGrossMarginPerc] = useState({})
    const [backlog, setBacklog] = useState({})

    const [prevContingency, setPrevContingency] = useState({})
    const [costPercent, setCostPercent] = useState({})
    const [actualHours, setActualHours] = useState({})
    const [hoursETC, setHoursETC] = useState({})
    const [mostRecentBill, setMostRecentBill] = useState({})
    const [earnedRevenue, setEarnedRevenue] = useState({})
    const [billings, setBillings] = useState({})
    const [overUnderBilled, setOverUnderBilled] = useState({})
    const [remainingToBill, setRemainingToBill] = useState({})
    const [expandCosts, setExpandCosts] = useState(false)
    const [expandBills, setExpandBills] = useState(false)
    const [earnedRevenueRows, setEarnedRevenueRows] = useState({})
    const [etcOverhead, setETCOverhead] = useState({})
    const [backlogFiltered, setBacklogFiltered] = useState([])
    const [backlogFilteredImage, setBacklogFilteredImage] = useState([])
    const sectionRefs = useRef([])
    const [highlightedJob, setHighlightedJob] = useState({})
    const [totalBudget, setTotalBudget] = useState(0)
    const [totalEAC, setTotalEAC] = useState(0)
    const [totalJobProfit, setTotalJobProfit] = useState(0)
    const [totalJobProfitPercent, setTotalJobProfitPercent] = useState(0)
    const [totalGrossMargin, setTotalGrossMargin] = useState(0)
    const [totalGrossMarginPercent, setTotalGrossMarginPercent] = useState(0)
    const [totalContingency, setTotalContingency] = useState(0)
    const [totalPrevContingency, setTotalPrevContingency] = useState(0)
    const [totalBacklog, setTotalBacklog] = useState(0)
    const [totalJobPerformanceChange, setTotalJobPerformanceChange] = useState(0)
    const [totalPrevWIP, setTotalPrevWIP] = useState(0)
    const [totalOverUnderBilled, setTotalOverUnderBilled] = useState(0)
    const [adminButton, setAdminButton] = useState(forceLoadAll || false)
    const [isExporting, setIsExporting] = useState(false)

    const [eacLabor, setEACLabor] = useState({})
    const [eacEquipment, setEACEquipment] = useState({})
    const [eacMaterials, setEACMaterials] = useState({})
    const [eacRentals, setEACRentals] = useState({})
    const [eacSubcontractors, setEACSubcontractors] = useState({})
    const [eacOther, setEACOther] = useState({})
    const [eacContingency, setEACContingency] = useState({})
    const [photoLocal, setPhotoLocal] = useState(photo)
    const [equipRates, setEquipRates] = useAtom(equipmentRatesAtom)

    const summaryPalette = {
        bg: '#f0f4fa', card: '#ffffff', border: '#e2e8f0',
        blue50: '#eff6ff', blue100: '#dbeafe', blue200: '#bfdbfe', blue300: '#93c5fd',
        blue500: '#3b82f6', blue700: '#1d4ed8',
        text: '#0f172a', muted: '#64748b',
        red: '#dc2626', redLight: '#fee2e2',
    };

    const buildSummaryPrompt = useCallback(() => {
        if (!backlogFiltered || backlogFiltered.length === 0) return null;
        // Wait until MOST jobs have derived data (EAC, jobProfit, grossMargin from later useEffects)
        const total = backlogFiltered.length;
        const readyCount = backlogFiltered.filter(j => EAC[j.BU_ID] && jobProfit[j.BU_ID] && grossMargin[j.BU_ID]).length;
        if (readyCount < total * 0.8) return null;
        // Also wait for totalPrevWIP to be computed (last in the chain — starts as number 0, becomes string after fNum)
        if (!forceLoadAll && typeof totalPrevWIP !== 'string') return null;

        // Strip formatting helper — removes commas, $, parens so AI reads clean numbers
        const c = (v) => v == null || v === '-' ? 0 : pNum(v);

        // Filter to active jobs (not 100% complete)
        const activeJobs = backlogFiltered.filter(j => {
            const pct = physicalComplete[j.BU_ID];
            return !pct || pct !== '100%' && pct !== '100.0%' && pNum(pct) < 100;
        });
        const jobsToSend = activeJobs.length > 0 ? activeJobs : backlogFiltered;

        const jobLines = jobsToSend.map(j => {
            const id = j.BU_ID;
            return [
                `${id} ${j.BU_Description || ''}`,
                `PM: ${j.Project_Manager_Name || 'N/A'}`,
                `Client: ${j.AR_AB_Name || 'N/A'}`,
                `Type: ${j.Cat_Code_BU_08 === 'TMN' ? 'NTE' : (j.Cat_Code_BU_08 || 'N/A')}`,
                `Actual Cost: ${c(actualCost[id])}`,
                `ETC: ${c(ETC[id])}`,
                `EAC: ${c(EAC[id])}`,
                `Profit: ${c(jobProfit[id])} (${c(jobProfitPerc[id])}%)`,
                `GM: ${c(grossMargin[id])} (${c(grossMarginPerc[id])}%)`,
                `Contingency: ${c(contingency[id])}`,
                `Backlog: ${c(backlog[id])}`,
                `Open Commitments: ${c(openCommitments[id])}`,
                `Complete: ${physicalComplete[id] || 'N/A'}`,
                `Prev WIP Profit: ${jobPrevWIP[id]?.total ? c(jobPrevWIP[id].total) : 'N/A'}`,
                `WIP Change: ${jobPrevWIP[id]?.total && jobProfit[id] ? c(jobProfit[id]) - c(jobPrevWIP[id].total) + c(contingency[id]) - c(prevContingency[id]) : 'N/A'}`,
            ].join(' | ');
        }).join('\n');

        return `Analyze this portfolio of ${jobsToSend.length} active construction jobs (${backlogFiltered.length} total, excluding 100% complete) for team "${selectedTeam || 'All'}":

Portfolio Totals: EAC=${c(totalEAC)}, Profit=${c(totalJobProfit)} (${c(totalJobProfitPercent)}%), GM=${c(totalGrossMargin)} (${c(totalGrossMarginPercent)}%), Contingency=${c(totalContingency)}, Backlog=${c(totalBacklog)}, WIP Gain/Fade=${c(totalPrevWIP)}

Jobs:\n${jobLines}

Negative values indicate losses. Profit = Contract Revenue minus EAC. WIP Change = current profit vs prior period profit.

Focus on: jobs at risk (low margins, cost overruns, negative WIP changes), portfolio-level trends, and actionable recommendations.`;
    }, [backlogFiltered, selectedTeam, totalEAC, totalJobProfit, totalJobProfitPercent, totalGrossMargin, totalGrossMarginPercent, totalContingency, totalBacklog, totalPrevWIP, jobProfit, jobProfitPerc, grossMargin, grossMarginPerc, backlog, physicalComplete, actualCost, ETC, EAC, contingency, openCommitments, jobPrevWIP, prevContingency]);

    const createExcel = () => {
        const rows = []
        filteredJobs.forEach((job) => {
            rows.push({
                "Job Number": job.BU_ID,
                "Work Type": job.Cat_Code_BU_08 == 'TMN' ? 'NTE' : job.Cat_Code_BU_08,
                "Project Manager": job.Project_Manager_Name || "",
                "Job Name": job.BU_Description,
                "Client": job.AR_AB_Name,
                "Status": job.Job_Status || '',
                "Labor": labor[job.BU_ID],
                "Equipment": equipmentCostType[job.BU_ID] + equipmentPhased[job.BU_ID],
                "Materials": materials[job.BU_ID],
                "Rentals": rentals[job.BU_ID],
                "Subcontractors": subcontractors[job.BU_ID],
                "Other": other[job.BU_ID],
                "Contingency": contingency[job.BU_ID],
                "Incentive": incentive[job.BU_ID],
                "Total": total[job.BU_ID],
                'Total Open Commitments': openCommitments[job.BU_ID],
                "Actual Cost": actualCost[job.BU_ID],
                "Cur Budget Revenue": curBudget[job.BU_ID],
                "Est Cost At Completion": EAC[job.BU_ID],
                "Forecasted Job Profit": jobProfit[job.BU_ID],
                "Job Profit": jobProfitPerc[job.BU_ID],
                "Overhead": pNum(actualOverhead[job.BU_ID]) + pNum(etcOverhead[job.BU_ID]),
                "Gross Margin": grossMargin[job.BU_ID],
                "Gross Margin %": grossMarginPerc[job.BU_ID],
                "Current Contingency": contingency[job.BU_ID],
                "Prev WIP Contingency": prevContingency[job.BU_ID],
                "Backlog": backlog[job.BU_ID],
                "Costs": costPercent[job.BU_ID],
                "Labor Hours": pNum(actualHours[job.BU_ID]) / (pNum(actualHours[job.BU_ID]) + pNum(hoursETC[job.BU_ID])),
                "Physical": physicalComplete[job.BU_ID],
                "Last Billing": mostRecentBill[job.BU_ID],
                "Earned Revenue": earnedRevenue[job.BU_ID],
                "Billings": billings[job.BU_ID],
                "Remaining to Bill": remainingToBill[job.BU_ID],
                "Over/Under Billed": overUnderBilled[job.BU_ID],
                "Job Performance Change": jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) + pNum(contingency[job.BU_ID]) - pNum(prevContingency[job.BU_ID]), 1) : '',
                "Prev. WIP": jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobPrevWIP[job.BU_ID]?.total), 1) : '',
                "Prev. WIP %": jobPrevWIP[job.BU_ID]?.percent ? fNum(jobPrevWIP[job.BU_ID]?.percent) + '%' : '',
                "Prev. WIP Gain/Fade $": jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total)) : '',
                "Prev. WIP Gain/Fade %": jobProfitPerc[job.BU_ID] && jobPrevWIP[job.BU_ID]?.percent ? fNum(pNum(jobProfitPerc[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.percent)) + '%' : '',
                "Start Date (Actual)": startDates[job.BU_ID],
                "Completion Date (Forecasted)": completionDates[job.BU_ID],
                "Mechanically Complete Date": mechCompleteDates[job.BU_ID]
            })
        })
    
        const ws = xlsx.utils.json_to_sheet(rows);

        const wsColumns = [
            { wpx: 90 },  // Job Number width
            { wpx: 90 },  // Work Type width
            { wpx: 120 }, // Project Manager width
            { wpx: 160 }, // Job Name width
            { wpx: 100 }, // Client width
            { wpx: 70 },  // Status width
            { wpx: 20 },  // Spacer or additional width as needed
            { wpx: 100 }, // Cur Budget Revenue width
            { wpx: 100 }, // Est Cost At Completion width
            { wpx: 100 }, // Forecasted Job Profit width
            { wpx: 100 }, // Job Profit width
            { wpx: 100 }, // Gross Margin width
            { wpx: 100 }, // Gross Margin % width
            { wpx: 20 },  // Spacer or additional width as needed
            { wpx: 100 }, // Current Contingency width
            { wpx: 100 }, // Prev WIP Contingency width
            { wpx: 100 }, // Backlog width
            { wpx: 20 },  // Spacer or additional width as needed
            { wpx: 100 }, // Costs width
            { wpx: 100 }, // Labor Hours width
            { wpx: 100 }, // Physical width
            { wpx: 20 },  // Spacer or additional width as needed
            { wpx: 100 }, // Last Billing width
            { wpx: 100 }, // Earned Revenue width
            { wpx: 100 }, // Billings width
            { wpx: 100 }, // Remaining to Bill width
            { wpx: 100 }, // Over/Under Billed width
            { wpx: 20 },  // Spacer or additional width as needed
            { wpx: 100 }, // Job Performance Change width
            { wpx: 100 }, // Prev. WIP width
            { wpx: 100 }, // Prev. WIP Gain/Fade $ width
            { wpx: 100 }, // Prev. WIP Gain/Fade % width
            { wpx: 100 }, // Start Date (Actual) width
            { wpx: 100 }, // Completion Date (Forecasted) width
            { wpx: 100 }, // Mechanically Complete Date width
        ];
        ws['!cols'] = wsColumns;

        // Create a new workbook and add the worksheet
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, 'summary');

        // Write the workbook to a file
        xlsx.writeFile(wb, selectedVersion + 'summary.xlsx');
    }

    const exportToExcel = async () => {
        // Generate dynamic filename
        const teamName = selectedTeam || 'AllTeams';
        const versionTimestamp = versionInfo?.Version_Start_DateTime ? moment(versionInfo.Version_Start_DateTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        const filename = `Fusion_JFC_Summary_${teamName}_${selectedVersion}_${versionTimestamp}.xlsx`;
        setIsExporting(true);
        
        // Helper function to convert percentage strings to decimals
        const percentToDecimal = (value) => {
            console.log('Converting value:', value);
            if (!value && value !== 0) return '';
            if (typeof value === 'string') {
                return pNum(value) / 100;
            }
            if (typeof value === 'number' && value > 1) {
                // If it's a number > 1, assume it's already a percentage (e.g., 6.59 for 6.59%)
                return value / 100;
            }
            return value;
        };
        
        try {
            const jobsData = filteredJobs.map((job) => ({
                'Job Number': job.BU_ID || '',
                'BU': job.Cat_Code_BU_27 || '',
                'Work Type': job.Cat_Code_BU_08 == 'TMN' ? 'NTE' : (job.Cat_Code_BU_08 || ''),
                'Project Manager': job.Project_Manager_Name || '',
                'Job Name': job.BU_Description || '',
                'Client': job.AR_AB_Name || '',
                'Status': job.Job_Status || '',
                'Cur Budget WIP': curBudget[job.BU_ID] || '',
                'Actual Cost': actualCost[job.BU_ID] || '',
                'Total Open Commitments': openCommitments[job.BU_ID] || '',
                'Labor': labor[job.BU_ID] || '',
                'Equipment': (pNum(equipmentCostType[job.BU_ID]) + pNum(equipmentPhased[job.BU_ID])) || '',
                'Materials': materials[job.BU_ID] || '',
                'Rentals': rentals[job.BU_ID] || '',
                'Subcontractors': subcontractors[job.BU_ID] || '',
                'Other': other[job.BU_ID] || '',
                'Incentive': incentive[job.BU_ID] || '',
                'Tot Cost At Completion': EAC[job.BU_ID] || '',
                'Forecasted Job Profit': jobProfit[job.BU_ID] || '',
                'Job Profit': percentToDecimal(jobProfitPerc[job.BU_ID]) || '',
                'Overhead': (pNum(actualOverhead[job.BU_ID]) + pNum(etcOverhead[job.BU_ID])) || '',
                'Gross Margin': grossMargin[job.BU_ID] || '',
                'Gross Margin %': percentToDecimal(grossMarginPerc[job.BU_ID]) || '',
                'Current OH Rate': percentToDecimal(ohPercent) || '',
                'Contingency': contingency[job.BU_ID] || '',
                'Prev Contingency': prevContingency[job.BU_ID] || '',
                'Backlog': backlog[job.BU_ID] || '',
                'Costs': percentToDecimal(costPercent[job.BU_ID]) || '',
                'Labor %': (pNum(actualHours[job.BU_ID]) && (pNum(actualHours[job.BU_ID]) + pNum(hoursETC[job.BU_ID]))) ? pNum(actualHours[job.BU_ID]) / (pNum(actualHours[job.BU_ID]) + pNum(hoursETC[job.BU_ID])) : '',
                'Physical': percentToDecimal(physicalComplete[job.BU_ID]) || '',
                'Last Billing': mostRecentBill[job.BU_ID] || '',
                'Earned Revenue': earnedRevenue[job.BU_ID] || '',
                'Billings': billings[job.BU_ID] || '',
                'Remaining to Bill': remainingToBill[job.BU_ID] || '',
                'Over/Under Billed': overUnderBilled[job.BU_ID] || '',
                'Job Performance Change': jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) + pNum(contingency[job.BU_ID]) - pNum(prevContingency[job.BU_ID]) : '',
                'Completion Date (Actual)': completionDates[job.BU_ID] || '',
                'Start Date (Actual)': startDates[job.BU_ID] || '',
                'Prev. WIP': jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobPrevWIP[job.BU_ID]?.total), 1) : '',
                'Prev. WIP %': percentToDecimal(jobPrevWIP[job.BU_ID]?.percent) || '',
                'Prev. WIP Gain/Prd %': percentToDecimal(jobPrevWIP[job.BU_ID]?.percent) || '',
                'Prev. WIP Gain/Prd $': jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) : '',
                'Mechanically Complete Date': mechCompleteDates[job.BU_ID] || ''
            }));

            console.log('Exporting Summary Data:', jobsData);

            const response = await fetch('https://forecastingtestpythonservice.azurewebsites.net/api/download_summary', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    jobs: jobsData,
                    versionInfo: {
                        forecastDate: versionInfo?.Version_Start_DateTime ? moment(versionInfo.Version_Start_DateTime).format('M/D/YYYY') : moment().format('M/D/YYYY'),
                        laborDate: versionInfo?.Version_Start_DateTime ? moment(versionInfo.Version_Start_DateTime).subtract(1, 'week').format('M/D/YYYY') : moment().subtract(1, 'week').format('M/D/YYYY')
                    },
                    metadata: {
                        jobId: selectedTeam || 'AllTeams',
                        jobName: selectedTeam || 'All Teams',
                        versionTimestamp: versionTimestamp
                    }
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);

            console.log('Summary Excel file downloaded successfully');
        } catch (error) {
            console.error('Error downloading Summary Excel file:', error);
            alert('Failed to download Summary Excel file. Please try again.');
        } finally {
            setIsExporting(false);
        }
    }

    const setLoadAll = () => {
        setAdminButton(!adminButton)
    }

    refSubNav ? refSubNav.current = { createExcel, setLoadAll, exportToExcel } : null

    useEffect(() => {
        const jobIds = filteredJobs.map(j => j.BU_ID)
        const overUnderBilled = {}
        const remainingToBill = {}
        let tOverUnderBilled = 0;

        jobIds.forEach((job) => {
            overUnderBilled[job] = pNum(billings[job]) - pNum(earnedRevenue[job])
            remainingToBill[job] = pNum(curBudget[job]) - pNum(billings[job])
            tOverUnderBilled = tOverUnderBilled + pNum(overUnderBilled[job])
        })
        setTotalOverUnderBilled(fNum(tOverUnderBilled, 1));
        setOverUnderBilled(overUnderBilled)
        setRemainingToBill(remainingToBill)
    }, [billings, earnedRevenue, curBudget, filteredJobs])

    useEffect(() => {
        if (selectedTeam) {
            setOhPercent(overheadData[selectedTeam] ? overheadData[selectedTeam] : '')
        }
    }, [selectedTeam, overheadData])

    // The team OH percentages load with a job (loadData.js). Opened with no job, the summary
    // loads them itself, or ETC OH is 0 and every Gross Margin leaves out the remaining OH.
    const overheadLoadedFor = useRef(null)
    useEffect(() => {
        if (!selectedVersion || Object.keys(overheadData || {}).length || overheadLoadedFor.current === selectedVersion) return
        overheadLoadedFor.current = selectedVersion
        loadOverheadData({ forecastGuid: selectedVersion }).then((data) => {
            const ohValues = {}
            data?.data?.forEach((d) => {
                ohValues[d?.Forecast_Row_ID] = { ...ohValues[d?.Forecast_Row_ID], [d.Forecast_Field_Name]: d.Forecast_Value }
            })
            const oh = {}
            Object.values(ohValues).forEach((value) => {
                oh[value.team] = value.percent
            })
            if (Object.keys(oh).length) setOverheadData(oh)
        })
    }, [selectedVersion, overheadData])

    useEffect(() => {
        const earnedRevenue = {}
        //console.log('earned revenue rows', earnedRevenueRows)
        earnedRevenueRows && Object.keys(earnedRevenueRows).forEach((job) => {
            earnedRevenue[job] = isNaN(pNum(earnedRevenueRows[job])) ? 0 : pNum(earnedRevenueRows[job]) * -1
        })


        const ohETC = {}
        const jobIds = filteredJobs.map(j => j.BU_ID)
        const ohTeamPercent = {}
        filteredJobs.forEach(job => {
            ohTeamPercent[job.BU_ID] = overheadData[job.Cat_Code_BU_27] ? overheadData[job.Cat_Code_BU_27] : ''
        })

        jobIds.forEach((job) => {
            const ohPer = ohTeamPercent[job] ? pNum(ohTeamPercent[job]) : 0
            const oh = curBudget[job] ? earnedRevenueRows[job] ? (pNum(curBudget[job]) + pNum(earnedRevenueRows[job])) * ohPer / 100 : pNum(curBudget[job]) * ohPer / 100 : ''
            const ohFormatted = oh < 0 ? '' : isNaN(pNum(oh)) ? 0 : pNum(oh)
            //console.log('oh per', job, ohPer, pNum(earnedRevenueRows[job]), pNum(curBudget[job]), oh)
            //if (job == '10124011')console.log('oh >>', job, curBudget[job], earnedRevenue[job], ohPer, oh)
            ohETC[job] = ohFormatted
        })
        //console.log('oh etc', ohETC)
        //if wrong check wip date for earned rev
        setETCOverhead(ohETC)
    }, [earnedRevenueRows, overheadData, curBudget])

    useEffect(() => {
        console.log('here in not loading')
        if (!fetchedAllJobUserData && filteredJobs?.length > 0) {
            console.log('here in loading')
            setFetchedAllJobUserData(true)
            const chOrValues = {}
            const dayZeroValues = {}
            const mechanicallyCompleteDates = {}
            const startDates = {}
            const completionDates = {}
            const physicalComplete = {}

            const jobIds = filteredJobs.map(j => j.BU_ID)
            const phasedEquipment = {}
            const phasedLabor = {}
            const laborValues = {}
            const equipmentValues = {}
            const contingData = {}
            const etcValues = {}
            const highlightedJob = {}
            const w = {}

            const etcRow = []
            const etcValue = 0

            // Split jobs into phased (tier 3 - more data per job) and non-phased for smarter batching
            const phasedJobIds = filteredJobs.filter(j => j.Cat_Code_BU_18 == '3' || j.Cat_Code_BU_16 == '3').map(j => j.BU_ID)
            const nonPhasedJobIds = jobIds.filter(id => !phasedJobIds.includes(id))

            const nonPhasedChunks = []
            for (let i = 0; i < nonPhasedJobIds.length; i += 150) {
                nonPhasedChunks.push(nonPhasedJobIds.slice(i, i + 150))
            }
            const phasedChunks = []
            for (let i = 0; i < phasedJobIds.length; i += 5) {
                phasedChunks.push(phasedJobIds.slice(i, i + 5))
            }
            const allChunks = [...nonPhasedChunks, ...phasedChunks]

            Promise.all(allChunks.map(chunk => loadTeamUserData({ ids: chunk, forecastGuid: selectedVersion }))).then((results) => {
                const data = results.flatMap(r => r?.data || [])
                if (onUserData) onUserData(data)
                // Field Bonus (51800) is retired for versions June 18, 2026 forward —
                // its ETC no longer counts toward labor / total EAC for those versions.
                const hideFieldBonus = fieldBonusRemoved(versionInfo?.Version_Start_DateTime)
                data.forEach((d) => {
                    if (d?.Forecast_Tab === 'Change Order') {
                        if (chOrValues[d?.BU_ID]) {
                            chOrValues[d?.BU_ID][d?.Forecast_User_Data_GUID || d?.Forecast_Row_ID] = { ...d, [d.Cost_Type]: d.Value_Amount, id: d.Row_Label }
                        } else {
                            chOrValues[d?.BU_ID] = {
                                [d?.Forecast_User_Data_GUID || d?.Forecast_Row_ID]: { ...d, [d.Cost_Type]: d.Value_Amount, id: d.Row_Label }
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Day Zero Budget') {
                        if (dayZeroValues[d?.BU_ID] && dayZeroValues[d?.BU_ID][d?.Forecast_Row_ID]) {
                            dayZeroValues[d?.BU_ID][d?.Forecast_Row_ID] = d 
                        } else if (dayZeroValues[d?.BU_ID]) {
                            dayZeroValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else {
                            dayZeroValues[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: d
                            }
                        }
                    }

                    if (d?.Forecast_Field_Name === 'mechanicallyComplete') {
                        mechanicallyCompleteDates[d?.BU_ID] = d?.Forecast_Value ? moment(d?.Forecast_Value).format('M/D/YYYY') : ''
                    } else if (d?.Forecast_Field_Name === 'startDateActual') {
                        startDates[d?.BU_ID] = d?.Forecast_Value ? moment(d?.Forecast_Value).format('M/D/YYYY') : ''
                    } else if (d?.Forecast_Field_Name === 'completionDateForecast') {
                        completionDates[d?.BU_ID] = d?.Forecast_Value ? moment(d?.Forecast_Value).format('M/D/YYYY') : ''
                    } else if (d?.Forecast_Field_Name === 'physicalComplete') {
                        physicalComplete[d?.BU_ID] = d?.Forecast_Value
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Labor') {
                        if (laborValues[d?.BU_ID]) {
                            laborValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else {
                            laborValues[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: d
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Equipment') {
                        if (equipmentValues[d?.BU_ID]) {
                            equipmentValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else {
                            equipmentValues[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: d
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Equipment Phased') {
                        if (phasedEquipment[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            phasedEquipment[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            }
                        } else if (phasedEquipment[d?.BU_ID]) {
                            phasedEquipment[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            } 
                        } else {
                            phasedEquipment[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    ...d
                                }
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Labor Phased') {
                        if (phasedLabor[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            phasedLabor[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            }
                        } else if (phasedLabor[d?.BU_ID]) {
                            phasedLabor[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            } 
                        } else {
                            phasedLabor[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    ...d
                                }
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Contingency') {
                        if (contingData[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            contingData[d?.BU_ID][d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        } else if (contingData[d?.BU_ID]) {
                            contingData[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                [d.Forecast_Field_Name]: d.Forecast_Value
                            }
                        } else {
                            contingData[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    [d.Forecast_Field_Name]: d.Forecast_Value
                                }
                            }
                        }
                    }

                    // Match bidForecast: count every saved ETC row regardless of which tab wrote it
                    // (All Third Party, Forecast grid, etc.) — a hardcoded tab list silently drops those.
                    if (d?.Cost_Type && d?.Forecast_Field_Name == 'etc' && !(hideFieldBonus && d?.Cost_Type == '51800') && (!d?.Cost_Code || d?.Cost_Code != '101101')) {
                        if(d?.BU_ID == '15525002' && d?.Cost_Type == '54200' && d?.Value_Amount)etcRow.push(d.Value_Amount)
                        if (etcValues[d?.BU_ID]?.[d?.Cost_Type]) {
                            if(d?.BU_ID == '15525002' && d?.Cost_Type == '54200')console.log('the row', d)
                            etcValues[d?.BU_ID][d?.Cost_Type] = etcValues[d?.BU_ID][d?.Cost_Type] + pNum(d?.Value_Amount)
                        } else if (etcValues[d?.BU_ID]) {
                            if(d?.BU_ID == '15525002' && d?.Cost_Type == '54200')console.log('the row 1', d)
                            etcValues[d?.BU_ID][d?.Cost_Type] = pNum(d?.Value_Amount)
                        } else {
                            if(d?.BU_ID == '15525002' && d?.Cost_Type == '54200')console.log('the row 2', d)
                            etcValues[d?.BU_ID] = {
                                [d?.Cost_Type]: pNum(d?. Value_Amount)
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Summary' && d?.Forecast_Field_Name === 'highlighted') {
                        highlightedJob[d?.BU_ID] = d?.Forecast_Value
                    }
                })

                console.log('etc values sub', etcRow)

                setEquipmentUserData(phasedEquipment)
                setHighlightedJob(highlightedJob)

                let etcLabor = {}
                let etcLaborDetails = {}
                let etcIncentive = {}
                let etcEquipment = {}
                let etcMaterials = {}
                let etcRentals = {}
                let etcSubcontractors = {}
                let etcOther = {}
                let etcContingency = {}
                let totalContingency = 0
                let etcTotal = {}
                let hours = {}

                //console.log('etcvalue', etcValues);
                //console.log('labor values', laborValues, 'equipment values', equipmentValues);
                console.log('phased labor', phasedLabor, 'phased equipment', phasedEquipment);

                // Fallback: if no completionDateForecast saved, use job's Planned_Complete_Date
                filteredJobs.forEach(j => {
                    if (!completionDates[j.BU_ID] && j.Planned_Complete_Date) {
                        completionDates[j.BU_ID] = moment(j.Planned_Complete_Date).format('M/D/YYYY')
                    }
                })

                //console.log('equipmentValues', equipmentValues);
                const totalCost = {}
                jobIds.forEach((job) => {
                    let regularTimeCostType = 0
                    let equipmentCostType = 0
                    let regularTime = 0
                    let regularHours = 0
                    let etc = 0
                    const pC = completionDates[job]


                    equipmentValues[job] && Object.keys(equipmentValues[job]).forEach((key) => {
                        if(job == '54025037')console.log('in add together', equipmentValues[job]?.[key], key.length == 10 && moment(key).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(pC).endOf('week').isAfter(key))
                        if (key.length == 10 && moment(key).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(pC).endOf('week').isAfter(key)) {
                            const row = equipmentValues[job]?.[key]
                            equipmentCostType = equipmentCostType + ((isNaN(pNum(row.Rate)) ? 0 : pNum(row.Rate)) * (isNaN(pNum(row.Number_Units)) ? 0 : pNum(row.Number_Units)) * (isNaN(pNum(row.Number_Hours)) ? 0 : pNum(row.Number_Hours)))
                            //if (job == '54024085') console.log('85 equipmentValues', equipmentCostType, row.burnPerHour, row.numOfWorkers, row.hoursPerWeek)
                        }
                        //totaleETC = equipmentCost
                    })

                    //console.log(laborValues[job]);
                    //if(job == '54024086') console.log('86 laborValues', laborValues[job], completionDates);

                    laborValues[job] && Object.values(laborValues[job]).forEach((row) => {
                        if (row) {
                            const week = row?.Forecast_Row_ID ? row.Forecast_Row_ID?.split('*')[0] : ''
                            const pC = completionDates[job]
                            if (week && moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(pC).endOf('week').isAfter(week)) {
                                regularTimeCostType = regularTimeCostType + (!isNaN(pNum(row.Rate)) && !isNaN(pNum(row.Number_Units)) && !isNaN(pNum(row.Number_Hours)) ? pNum(row.Rate) * pNum(row.Number_Units) * pNum(row.Number_Hours) : 0)
                                regularHours = regularHours + (!isNaN(pNum(row.Number_Hours)) && !isNaN(pNum(row.Number_Units)) ? pNum(row.Number_Hours) * pNum(row.Number_Units) : 0)
                            }
                        }
                    })


                    phasedLabor[job] && Object.keys(phasedLabor[job]).forEach((row) => {
                        const weekRow = row.includes('=')
                        const week = row.split('=')[1]
                        const phase = row.split('=')[0]
                        const pC = completionDates[job]
                        const phaseDetails = phase ? phasedLabor[job][phase] : {}
                        const withinProject = moment(week).isAfter(moment(versionInfo.Version_Start_DateTime).startOf('week')) && moment(week).isBefore(moment(pC).endOf('week'))
                        const withinStartStop = true//moment(week).isAfter(moment(phaseDetails?.startDate).startOf('week')) && moment(week).isBefore(moment(phaseDetails?.endDate).endOf('week'))
                        const h = phasedLabor[job][row]?.Number_Hours ? phasedLabor[job][row].Number_Hours : 0
                        const bR = phasedLabor[job][row]?.Rate ? phasedLabor[job][row].Rate : 0
                        const cS = phasedLabor[job][row]?.Number_Units ? phasedLabor[job][row].Number_Units : 0
                        if (job == '54026013' && withinProject) console.log('in add together', phase, week, (!isNaN(pNum(h)) && !isNaN(pNum(bR)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(bR) * pNum(cS) : 0))
                        if (weekRow && phasedLabor[job][row] && h && bR && cS && withinProject && withinStartStop) {
                            regularHours = regularHours + (!isNaN(pNum(h)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(cS) : 0)
                            regularTime = regularTime + (!isNaN(pNum(h)) && !isNaN(pNum(bR)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(bR) * pNum(cS) : 0)
                        }
                    })

                    let labor = 0
                    let materials = 0
                    let equipment = 0
                    let rentals = 0
                    let subcontractors = 0
                    let other = 0
                    let contingency = 0
                    let total = 0

                    etcValues[job] && Object.keys(etcValues[job]).forEach((row) => {
                        etc = etc + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        //if(job == '54024086') console.log(etcValues[job][row][0], job, row, labor, rentals, materials, subcontractors, other);
                        if (row[0] == '5' && row[1] == '1' && (row[2] == '6' || row[2] == '7' || row[2] == '8')) {
                            labor = labor + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && row[1] == '2') {
                            rentals = rentals + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && row[1] == '3') {
                            materials = materials + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && row[1] == '4') {
                            subcontractors = subcontractors + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                            if(job == '12425029') console.log('29 sub', etcValues[job][row], subcontractors);
                        } else if (row[0] == '5' && (row[1] == '5' || row[1] == '6' || row[1] == '7')) {
                            if(job == '54025036') console.log('36 other', etcValues, row, etcValues[job][row], other);
                            other = other + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        }
                    })

                    let totalcLabor = 0
                    let totalcEquipment = 0
                    let totalcMaterials = 0
                    let totalcSubcontractors = 0
                    let totalcOtherExpenses = 0
                    let totalcTotal = 0

                    contingData[job] && Object.values(contingData[job]).forEach((row) => {
                        totalcLabor = totalcLabor + (isNaN(pNum(row.CurrentLabor)) ? 0 : pNum(row.CurrentLabor))
                        totalcEquipment = totalcEquipment + (isNaN(pNum(row.CurrentEquipment)) ? 0 : pNum(row.CurrentEquipment))
                        totalcMaterials = totalcMaterials + (isNaN(pNum(row.CurrentMaterials)) ? 0 : pNum(row.CurrentMaterials))
                        totalcSubcontractors = totalcSubcontractors + (isNaN(pNum(row.CurrentSubs)) ? 0 : pNum(row.CurrentSubs))
                        totalcOtherExpenses = totalcOtherExpenses + (isNaN(pNum(row.CurrentOther)) ? 0 : pNum(row.CurrentOther))
                    })
                    totalcTotal = totalcLabor + totalcEquipment + totalcMaterials + totalcSubcontractors + totalcOtherExpenses

                    //totalCost[job] = equipmentETC + regularTime + etc + totalcTotal
                    hours[job] = regularHours
                    etcLaborDetails[job] = {labor: labor, regularTimeCostType: regularTimeCostType, regularTime: regularTime}
                    etcLabor[job] = labor + regularTimeCostType + regularTime
                    etcIncentive[job] = labor
                    etcEquipment[job] = equipmentCostType
                    etcMaterials[job] = materials
                    etcRentals[job] = rentals
                    etcSubcontractors[job] = subcontractors
                    etcOther[job] = other
                    etcContingency[job] = totalcTotal
                    totalContingency = totalContingency + totalcTotal
                    etcTotal[job] = labor + regularTimeCostType + regularTime + equipmentCostType + materials + rentals + subcontractors + other + totalcTotal
                })

                console.log('labor details', etcLaborDetails, laborValues);
                //console.log('etcEq', etcEquipment, equipmentValues);

                setHoursETC(hours)
                setLabor(etcLabor)
                setEquipmentCostType(etcEquipment)
                setMaterials(etcMaterials)
                setRentals(etcRentals)
                setSubcontractors(etcSubcontractors)
                setOther(etcOther)
                setContingency(etcContingency)
                setTotalContingency(fNum(totalContingency, 1))
                setIncentive(etcIncentive)
                setTotal(etcTotal)
                setETC(etcTotal)

                let curBudget = {}
                let totalBudget = 0
                filteredJobs.forEach((job) => {
                    let jobCurBudget = 0
                    dayZeroValues[job.BU_ID] && Object.values(dayZeroValues[job.BU_ID]).forEach((row) => {
                        if (row['Cost_Type'] && row['Cost_Type'].length) {
                            if (row['Cost_Type'][0] == '4') {
                                jobCurBudget = jobCurBudget + pNum(row['Value_Amount'])
                            }
                        }
                    })

                    //console.log('day zero', job.BU_ID, jobCurBudget);

                    chOrValues[job.BU_ID] && Object.values(chOrValues[job.BU_ID]).forEach((row) => {
                        if (row.Status === 'Approved') {
                            jobCurBudget = jobCurBudget + (isNaN(pNum(row['41000'])) ? 0 : pNum(row['41000']))
                            // jobCurBudget = jobCurBudget + (isNaN(pNum(row.tAndM)) ? 0 : pNum(row.tAndM))
                            // jobCurBudget = jobCurBudget + (isNaN(pNum(row.changeOrders)) ? 0 : pNum(row.changeOrders))
                            // jobCurBudget = jobCurBudget + (isNaN(pNum(row.reductionOfScope)) ? 0 : pNum(row.reductionOfScope))
                        }
                    })
                    //console.log('change orders', job.BU_ID, jobCurBudget);
                    curBudget[job.BU_ID] = jobCurBudget > 0 ? fNum(jobCurBudget, 1) : ''
                    totalBudget = totalBudget + (jobCurBudget > 0 ? jobCurBudget : 0)
                })
                setCurBudget(curBudget)
                setTotalBudget(fNum(totalBudget, 1))
                setStartDates(startDates)
                setCompletionDates(completionDates)
                setMechCompleteDates(mechanicallyCompleteDates)
                setPhysicalComplete(physicalComplete)
            })

            if (!forceLoadAll) {
            Promise.all(allChunks.map(chunk => loadTeamUserData({ ids: chunk, forecastGuid: selectedWIP?.Version_GUID }))).then((results) => {
                const data = results.flatMap(r => r?.data || [])
                let contData = {}
                let totalPrevContingency = 0
                //console.log('wip data', data);
                data.forEach((d) => {
                    if (d?.Forecast_Tab === 'Contingency') {
                        if (contData[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            contData[d?.BU_ID][d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        } else if (contData[d?.BU_ID]) {
                            contData[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                [d.Forecast_Field_Name]: d.Forecast_Value
                            }
                        } else {
                            contData[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    [d.Forecast_Field_Name]: d.Forecast_Value
                                }
                            }
                        }
                    }
                })
                //console.log('cont data', contData)
                jobIds.forEach((job) => {
                    let totalLabor = 0
                    let totalEquipment = 0
                    let totalMaterials = 0
                    let totalSubcontractors = 0
                    let totalOtherExpenses = 0
                    contData[job] && Object.values(contData[job]).forEach((row) => {
                        totalLabor = totalLabor + (isNaN(pNum(row.CurrentLabor)) ? 0 : pNum(row.CurrentLabor))
                        totalEquipment = totalEquipment + (isNaN(pNum(row.CurrentEquipment)) ? 0 : pNum(row.CurrentEquipment))
                        totalMaterials = totalMaterials + (isNaN(pNum(row.CurrentMaterials)) ? 0 : pNum(row.CurrentMaterials))
                        totalSubcontractors = totalSubcontractors + (isNaN(pNum(row.CurrentSubs)) ? 0 : pNum(row.CurrentSubs))
                        totalOtherExpenses = totalOtherExpenses + (isNaN(pNum(row.CurrentOther)) ? 0 : pNum(row.CurrentOther))
                    })
                    const totalcTotal = totalLabor + totalEquipment + totalMaterials + totalSubcontractors + totalOtherExpenses
                    contData[job] = totalcTotal
                    totalPrevContingency = totalPrevContingency + totalcTotal
                })
                setPrevContingency(contData)
                setTotalPrevContingency(fNum(totalPrevContingency, 1))
            })
            }

            const jobIds1 = jobIds//.slice(0, 40)
            //const jobIds2 = jobIds.slice(40, jobIds.length)
            let actualCost = {}
            let actualOverhead = {}
            let hours = {}
            let revenue = {}
            let revenuePrevPeriod = {}
            loadTeamCostDetail({ ids: jobIds1, forecastGuid: selectedVersion, wip: moment().add(1, 'month').format('YYYY-MM-DD') }).then((data) => {
                //console.log('cost detail', data);
                //setTeamCostDetail(data?.data)
                data?.data?.forEach((d) => {
                    if ((d?.Cost_Category == 'Job Cost - All Others' || d?.Cost_Category == 'Job Cost - Labor') && actualCost[d?.Job_Number]) {
                        actualCost[d?.Job_Number] = actualCost[d?.Job_Number] + (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    } else if (d?.Cost_Category == 'Job Cost - All Others' || d?.Cost_Category == 'Job Cost - Labor') {
                        actualCost[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }

                    if (d?.Cost_Category == 'OH' && actualOverhead[d?.Job_Number]) {
                        actualOverhead[d?.Job_Number] = actualOverhead[d?.Job_Number] + (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    } else if (d?.Cost_Category == 'OH') {
                        actualOverhead[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }

                    if (d?.Cost_Category == 'Job Cost - Labor' && hours[d?.Job_Number]) {
                        hours[d?.Job_Number] = hours[d?.Job_Number] + (isNaN(pNum(d?.Total_Hours)) ? 0 : pNum(d?.Total_Hours))
                    } else if (d?.Cost_Category == 'Job Cost - Labor') {
                        hours[d?.Job_Number] = (isNaN(pNum(d?.Total_Hours)) ? 0 : pNum(d?.Total_Hours))
                    }

                    if (d?.Cost_Category == 'Revenue' && revenue[d?.Job_Number]) {
                        revenue[d?.Job_Number] = revenue[d?.Job_Number] + (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    } else if (d?.Cost_Category == 'Revenue') {
                        revenue[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }

                })
                //setEarnedRevenue(revenue)
                //console.log( 'actualCost', actualCost);
                setActualHours(hours)
                setActualCost(actualCost)
                setActualOverhead(actualOverhead)
                if (onCostDetailData) onCostDetailData(data?.data)
            })

            const wipDate = selectedWIP?.Version_Start_DateTime ? moment(selectedWIP?.Version_Start_DateTime).endOf('month').format('YYYY-MM-DD') : ''
            if (!forceLoadAll) {
            loadTeamCostDetail({ ids: jobIds1, forecastGuid: selectedVersion, wip: wipDate }).then((data) => {
                data?.data?.forEach((d) => {
                    if (d?.Cost_Category == 'Revenue') {
                        revenuePrevPeriod[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }
                })
                //console.log('earned rev rows', revenuePrevPeriod, wipDate, data?.data);
                setEarnedRevenueRows(revenuePrevPeriod)
            })
            }

            let openCommitments = {}
            let openCommitmentsBreakout = {}
            loadTeamOpemCommitments({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
                data?.data?.forEach((d) => {
                    if (d?.Cost_Type_Code?.[0] == '5' && openCommitments[d?.Job_Number]) {
                        openCommitments[d?.Job_Number] = openCommitments[d?.Job_Number] + (isNaN(pNum(d?.PO_True_Open_Amount)) ? 0 : pNum(d?.PO_True_Open_Amount))
                    } else if (d?.Cost_Type_Code?.[0] == '5') {
                        openCommitments[d?.Job_Number] = (isNaN(pNum(d?.PO_True_Open_Amount)) ? 0 : pNum(d?.PO_True_Open_Amount))
                    }
                })
                //console.log( 'openCommitments', openCommitments, data?.data);
                setOpenCommitments(openCommitments)
                if (onCommitmentsData) onCommitmentsData(data?.data)
            })

            loadCostDetailBillings({ ids: jobIds, version: selectedVersion }).then((data) => {
                const jobBillings = {};
                data?.data?.forEach((d) => {
                    jobBillings[d?.Job_Number] = -d.Total_Job_Cost
                });
                setBillings(jobBillings);
            })

            loadTeamBillings({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
                let mostRecent = {}
                const billingData = {}
                const billings = {}
                data?.data?.forEach((d) => {
                    if (billingData[d?.Job_Number]) {
                        billingData[d?.Job_Number].push(d)
                    } else {
                        billingData[d?.Job_Number] = [d]
                    }
                })


                Object.values(billingData).forEach((bills) => {
                    let mostRecentCostDate = '2021-01-01'
                    let invoices = 0
                    bills.forEach((d) => {
                        if (d?.GL_Date && moment(d?.GL_Date).isAfter(moment(mostRecentCostDate))) {
                            mostRecentCostDate = moment(d?.GL_Date).format('M/D/YYYY')
                        }
                        invoices = invoices + pNum(d?.Invoice_Amount)
                    })
                    mostRecent[bills[0]?.Job_Number] = mostRecentCostDate
                    billings[bills[0]?.Job_Number] = invoices
                })
                setMostRecentBill(mostRecent)
                //setBillings(billings)
                if (onBillingsData) onBillingsData(data?.data)
            })

            //jobIds && jobIds.forEach((job, index) => {
            if (!forceLoadAll) {
            loadSummaryWIPArray({ ids: jobIds, wip: wipDate }).then((data) => {
                //if (index == 10) console.log('prevWIP', data);
                //console.log('prevWIP', data);
                let rev = {}
                let cost = {}
                let oh = {}
                let w = {}
                data?.data.forEach((d) => {
                    if (d?.Account_Category === 'Revenue' && rev[d?.BU_ID]) {
                        rev[d.BU_ID] = rev[d.BU_ID] + (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'Revenue') {
                        rev[d.BU_ID] = (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'Job Cost' && cost[d?.BU_ID]) {
                        cost[d.BU_ID] = cost[d.BU_ID] + (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'Job Cost') {
                        cost[d.BU_ID] = (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'OH' && oh[d?.BU_ID]) {
                        oh[d.BU_ID] = oh[d.BU_ID] + (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'OH') {
                        oh[d.BU_ID] = (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    }
                })
                //console.log('prevWIP', wipDate, rev, cost, oh);
                //if (job == '50223020') console.log('prevWIP', wipDate, job, rev, cost, oh);
                jobIds.forEach((job) => {
                    w[job] = {
                        revenue: rev[job],
                        cost: cost[job],
                        overhead: oh[job],
                        total: -rev[job] - cost[job],
                        percent: rev[job] ? fNum((-rev[job] - cost[job]) / -rev[job] * 100) : ''
                    }
                })
                setJobPrevWIP(w)
            })
            }
            //})

        }

    }, [filteredJobs])

    useEffect(() => {
        const phasedEquipmentCost = {}
        const equipmentRates = {}
        const jobIds = filteredJobs.map(j => j.BU_ID)
        jobIds.forEach((job) => {
            equipmentUserData[job] && Object.keys(equipmentUserData[job]).forEach((row) => {
                if (equipmentUserData[job]?.[row]?.weekPerUnit) {
                    equipmentRates[equipmentUserData[job][row].asset] = equipmentUserData[job][row].weekPerUnit
                }
            })
        })

        console.log('equipmentRates', equipmentRates, 'equipRates', equipRates, 'equipmentUserData', equipmentUserData)

        jobIds.forEach((job) => {
            let equipmentETC = 0
            let equip = {}
            const added = {}
            //if(job == '54025034')console.log('equip 1', job, equipmentUserData[job], equipmentRates, equipRates)
            equipmentUserData[job] && Object.keys(equipmentUserData[job]).forEach((t) => {
                const r = equipmentUserData[job][t]
                const pC = completionDates[job]
                const v = versionInfo?.Version_Start_DateTime

                // Row IDs use '=' (new) or '*' (legacy) between name and week
                const _sep = t.includes('=') ? '=' : '*'
                const _idx = t.lastIndexOf(_sep)
                const w = _idx >= 0 ? t.substring(_idx + 1) : undefined
                const e = _idx >= 0 ? t.substring(0, _idx) : t
                // Price each week off its own saved Rate only — matches bidForecast's LEMSO
                // detail. The old asset-header fallback (equipmentUserData[job][e].Rate)
                // resurrected weeks whose weekly Rate was zeroed by a half-written save,
                // inflating Internal Equipment (e.g. the phantom 3,722 on the 2026-06-15 week).
                const rate = r?.Rate ? r.Rate : 0
                const h = r?.Number_Hours
                const n = r?.Number_Units
                //console.log('e1', job, t, rate, equipmentUserData[job][t])
                if (w && h && n && rate && moment(w).isAfter(moment(v).startOf('week')) && moment(w).isBefore(moment(pC).endOf('week'))) {
                    if (!equip[e]) equip[e] = {}
                    if (!equip[e][w]) equip[e][w] = { rate: rate, h: isNaN(pNum(h)) ? 0 : pNum(h), n: isNaN(pNum(n)) ? 0 : pNum(n), total: 0 }
                    equip[e][w].rate = rate
                    equip[e][w].h = equip[e][w].h + (isNaN(pNum(h)) ? 0 : pNum(h))
                    equip[e][w].n = equip[e][w].n + (isNaN(pNum(n)) ? 0 : pNum(n))
                    equip[e][w].total = equip[e][w].rate * equip[e][w].h * equip[e][w].n

                    //console.log('e2', e, job, w, rate, equipRates[e], equipmentRates[e], equipmentETC, (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0))
                    equipmentETC = equipmentETC + (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0)

                    if (!added[e]) {
                        added[e] = [{ w: w, cur: equipmentETC, rate: equip[e][w].rate, n: equip[e][w].n, h: equip[e][w].h }]
                    } else {
                        added[e].push({ w: w, cur: equipmentETC, rate: equip[e][w].rate, n: equip[e][w].n, h: equip[e][w].h })
                    }

                }
            })
            //if (job == '12425018')console.log('added', added)
            //if (equipmentETC) console.log( 'e3', job, equipmentETC)
            //if(job == '54025034')console.log('equip', job, equip)
            phasedEquipmentCost[job] = equipmentETC

        })
        //console.log( 'phasedEquipmentCost', phasedEquipmentCost);
        setEquipmentPhased(phasedEquipmentCost)
    }, [equipmentUserData, equipRates, completionDates, filteredJobs])

    useEffect(() => {
        const jobIds = filteredJobs.map(j => j.BU_ID)
        const etc = {}
        jobIds.forEach((job) => {
            let etcTotal = labor[job] + materials[job] + rentals[job] + subcontractors[job] + other[job] + equipmentPhased[job] + equipmentCostType[job] + contingency[job]
            etc[job] = etcTotal
        })
        setETC(etc)
        setTotal(etc)
    }, [equipmentPhased, equipmentCostType, contingency])

    useEffect(() => {
        let EAC = {}
        let totalEAC = 0
        let jobProfit = {}
        let totalProfit = 0
        let jobProfitPerc = {}
        let jobGrossMargin = {}
        let totalGrossMargin = 0
        let jobGrossMarginPerc = {}
        let backlog = {}
        let totalBacklog = 0
        let costPercent = {}
        let earnedRevenue = {}
        //console.log('first', curBudget[filteredJobs[7]?.BU_ID], 'a', openCommitments[filteredJobs[7]?.BU_ID], ETC[filteredJobs[7]?.BU_ID], actualCost[filteredJobs[7]?.BU_ID])
        filteredJobs.forEach((job, index) => {
            const total = (pNum(actualCost[job.BU_ID]) + pNum(openCommitments[job.BU_ID]) + pNum(ETC[job.BU_ID]))
            EAC[job.BU_ID] = total > 0 ? fNum(total, 1) : ''
            totalEAC = totalEAC + (total > 0 ? total : 0)
            //if(index == 7) console.log('second', total, 'b', curBudget[job.BU_ID])
            jobProfit[job.BU_ID] = total > 0 && curBudget[job.BU_ID] ? fNum(pNum(curBudget[job.BU_ID]) - total, 1) : ''
            totalProfit = totalProfit + (jobProfit[job.BU_ID] ? pNum(jobProfit[job.BU_ID]) : 0)
            jobProfitPerc[job.BU_ID] = jobProfit[job.BU_ID] ? fNum(pNum(jobProfit[job.BU_ID]) / pNum(curBudget[job.BU_ID]) * 100) : ''

            //if (job.BU_ID == '50224024')console.log('job profit', curBudget[job.BU_ID], total, actualOverhead, actualOverhead[job.BU_ID], etcOverhead[job.BU_ID])
            const grossMargin = (pNum(curBudget[job.BU_ID]) - total - (isNaN(pNum(actualOverhead[job.BU_ID])) ? 0 : pNum(actualOverhead[job.BU_ID]))) - (isNaN(pNum(etcOverhead[job.BU_ID])) ? 0 : pNum(etcOverhead[job.BU_ID]))
            totalGrossMargin = totalGrossMargin + grossMargin
            const grossMarginPerc = grossMargin && curBudget[job.BU_ID] ? fNum(grossMargin / pNum(curBudget[job.BU_ID]) * 100) : ''
            jobGrossMargin[job.BU_ID] = grossMargin
            jobGrossMarginPerc[job.BU_ID] = grossMarginPerc

            backlog[job.BU_ID] = (1 - (pNum(actualCost[job.BU_ID]) / total)) * pNum(curBudget[job.BU_ID])
            totalBacklog = totalBacklog + (backlog[job.BU_ID] ? pNum(backlog[job.BU_ID]) : 0)
            costPercent[job.BU_ID] = total ? (pNum(actualCost[job.BU_ID]) / total) * 100 : ''
            earnedRevenue[job.BU_ID] = (costPercent[job.BU_ID] / 100) * pNum(curBudget[job.BU_ID])
        })
        // console.log('job profit', jobProfit)
        setEAC(EAC)
        setTotalEAC(fNum(totalEAC, 1))
        setJobProfit(jobProfit)
        setTotalJobProfit(fNum(totalProfit, 1))
        setJobProfitPerc(jobProfitPerc)
        setTotalJobProfitPercent(fNum(totalProfit / pNum(totalBudget) * 100, 2) + '%')
        setGrossMargin(jobGrossMargin)
        setTotalGrossMargin(fNum(totalGrossMargin, 1))
        setGrossMarginPerc(jobGrossMarginPerc)
        setTotalGrossMarginPercent(fNum(totalGrossMargin / pNum(totalBudget) * 100, 2) + '%')
        setBacklog(backlog)
        setTotalBacklog(fNum(totalBacklog, 1))
        setCostPercent(costPercent)
        setEarnedRevenue(earnedRevenue)

        // Report computed data to parent if callback provided
        if (onSummaryData) {
            onSummaryData({ EAC, curBudget, jobProfit, jobProfitPerc, jobGrossMargin: jobGrossMargin, jobGrossMarginPerc: jobGrossMarginPerc })
        }

    }, [openCommitments, actualCost, ETC, curBudget, totalBudget, actualOverhead, etcOverhead])

    useEffect(() => {
        let totalJobPerformanceChange = 0
        let totalPrevWIP = 0
        filteredJobs.forEach((job) => {
            //if(job.BU_ID == '54025035')console.log('job', job, jobProfit[job.BU_ID], jobPrevWIP[job.BU_ID]?.total, contingency[job.BU_ID], prevContingency[job.BU_ID])
            const jobPerformanceChange = jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) + pNum(contingency[job.BU_ID]) - pNum(prevContingency[job.BU_ID]) : 0
            const prevWIP = jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) : 0
            totalJobPerformanceChange = totalJobPerformanceChange + jobPerformanceChange
            totalPrevWIP = totalPrevWIP + prevWIP
        })
        setTotalJobPerformanceChange(fNum(totalJobPerformanceChange, 1))
        setTotalPrevWIP(fNum(totalPrevWIP, 1))
    }, [jobProfit, jobPrevWIP, contingency, prevContingency])

    const divideIntoSections = (logs) => {
        let sections = [];
        const sectionSize = 37;
        //console.log('logs', logs, sectionSize)
        for (let i = 0; i < logs.length; i += sectionSize) {
            //console.log('adding section', logs.slice(i, i + sectionSize))
            sections.push(logs.slice(i, i + sectionSize));
        }
        //console.log('summary sections', sections)
        return sections;
    }

    useEffect(() => {
        const sortedBacklog = filteredJobs.sort((a, b) => {
            const backlogA = backlog[a.BU_ID] || 0;
            const backlogB = backlog[b.BU_ID] || 0;

            return backlogB - backlogA; // Sort descending
        });
        //const filteredBacklog = sortedBacklog.filter(job => job.BU_ID !== '54025036' && job.BU_ID !== '54025035');
        setBacklogFiltered(sortedBacklog);
        //console.log('sortedBacklog', divideIntoSections(sortedBacklog))
        setBacklogFilteredImage(divideIntoSections(sortedBacklog))
    }, [filteredJobs, backlog])

    useEffect(() => {
        versions && versions.length > 0 && setVersionInfo(versions.find(v => v.Version_GUID === selectedVersion))
    }, [versions, selectedVersion]);

    useEffect(() => {
        let filtered = []
        filtered = jobs ? jobs.filter(a => a.Cat_Code_BU_27 == selectedTeam).filter(a => a.Cat_Code_BU_08 != 'T&M') : []
        if (adminButton) {
            filtered = jobs ? jobs.filter(a => a.Cat_Code_BU_08 != 'T&M') : []
            setFetchedAllJobUserData(false)
        }
        console.log('jobs a', filtered, selectedTeam, jobs[0])
        setFilteredJobs(filtered)
    }, [jobs, adminButton, selectedTeam])


    const s = StyleSheet.create({
        cell: {
            height: 20,
            border: '1px solid #d9d9d9',
            borderRight: '0px solid #d9d9d9',
            padding: 3,
            textWrap: 'nowrap',
            overflow: 'hidden',
            textAlign: 'right',
            color: '#000',
            fontSize: 11
        },
        cellt: {
            border: '1px solid #d9d9d9',
            borderRight: '1px solid #d9d9d9',
            padding: 2,
            fontSize: 10,
            flexWrap: 'wrap',
            wordWrap: 'break-word',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex'
        },
        celll: {
            height: 20,
            border: '1px solid #d9d9d9',
            borderRight: '0px solid #d9d9d9',
            padding: 3,
            textWrap: 'nowrap',
            overflow: 'hidden',
            textAlign: 'left',
            fontSize: 11
        }
    });

    useEffect(() => {
        if (photo) {
            backlogFilteredImage.forEach((_, index) => {
                if (!sectionRefs.current[index]) {
                    sectionRefs.current[index] = React.createRef();
                }
            });
            setJobRef(job, 'summary', sectionRefs.current)
        }
    }, [backlogFilteredImage]);

    const Row = ({ job }) => {
        const [highlighted, setHighlighted] = useState(highlightedJob[job.BU_ID] || false)

        const saveValue = (value) => {
            let data = {
                userId: '154045',
                userName: 'Seth Bailey',
                fieldName: 'highlighted',
                tab: "Summary",
                rowId: job.BU_ID,
                version: selectedVersion + '',
                value: value + '',
                id: job.BU_ID,
                lockedVersion: lockedVersion
            }
            console.log('saving data', data)
            updateUserDataArray(data)
        }

        return (
            <View>
                {((photoLocal && (curBudget[job.BU_ID] || EAC[job.BU_ID])) || !photoLocal) ? <Pressable
                    onPress={() => {
                        if (!highlighted) {
                            setHighlighted('first')
                            saveValue('first')
                        } else if (highlighted == 'first') {
                            setHighlighted('second')
                            saveValue('second')
                        } else {
                            setHighlighted(false)
                            saveValue('false')
                        }
                    }}
                    style={{ flexDirection: 'row', paddingBottom: 0, backgroundColor: highlighted == 'first' ? '#ffe699' : highlighted == 'second' ? '#ebebeb' : '' }}>
                    {photoLocal ? null : <Text style={[s.celll, { width: 70 }]}>{job.BU_ID}</Text>}
                    <Text style={[s.celll, { width: 40 }]}>{job.Cat_Code_BU_08 == 'TMN' ? 'NTE' : job.Cat_Code_BU_08}</Text>
                    {photoLocal ? null : <Text style={[s.celll, { width: 110 }]}>{job.Project_Manager_Name || ''}</Text>}
                    {photoLocal ? <Text style={[s.celll, { width: 64, fontSize: 11 }]}>{job.BU_ID}</Text> : null}
                    <Text style={[s.celll, { width: 160 }]}>{job.BU_Description}</Text>
                    {hideProgram ? null : <Text style={[s.celll, { width: 150 }]}>{job.Cat_Code_BU_38_Description}</Text>}
                    <Text style={[s.celll, { width: 100, borderRight: '1px solid #d9d9d9' }]}>{job.AR_AB_Name}</Text>
                    {photoLocal ? null : <Text style={[s.celll, { width: 60, borderRight: '1px solid #d9d9d9' }]}>{job.Job_Status || ''}</Text>}
                    {expandCosts ? <View style={{ flexDirection: 'row' }}>
                        <View style={{ width: 5 }}></View>
                        <Text style={[s.cell, { width: 80 }]}>{actualCost[job.BU_ID] ? fNum(pNum(actualCost[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{openCommitments[job.BU_ID] ? fNum(pNum(openCommitments[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{labor[job.BU_ID] ? fNum(pNum(labor[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{equipmentCostType[job.BU_ID] || equipmentPhased[job.BU_ID] ? fNum(pNum(equipmentCostType[job.BU_ID]) + pNum(equipmentPhased[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{materials[job.BU_ID] ? fNum(pNum(materials[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{rentals[job.BU_ID] ? fNum(pNum(rentals[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{subcontractors[job.BU_ID] ? fNum(pNum(subcontractors[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{other[job.BU_ID] ? fNum(pNum(other[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{contingency[job.BU_ID] ? fNum(pNum(contingency[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{incentive[job.BU_ID] ? fNum(pNum(incentive[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80, borderRight: '1px solid #d9d9d9' }]}>{total[job.BU_ID] ? fNum(pNum(total[job.BU_ID]), 1) : ''}</Text>
                    </View> : null}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 80 }]}>{curBudget[job.BU_ID] ? fNum(pNum(curBudget[job.BU_ID]), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 80 }]}>{EAC[job.BU_ID] ? fNum(pNum(EAC[job.BU_ID]), 1) : ''}</Text>
                    {/* <Text style={[s.cell, { width: 80 }]}>{actualCost[job.BU_ID] ? fNum(pNum(actualCost[job.BU_ID]), 1) : ''}</Text>
                <Text style={[s.cell, { width: 80 }]}>{openCommitments[job.BU_ID] ? fNum(pNum(openCommitments[job.BU_ID]), 1) : ''}</Text>
                <Text style={[s.cell, { width: 80 }]}>{total[job.BU_ID] ? fNum(pNum(total[job.BU_ID]), 1) : ''}</Text> */}
                    <Text style={[s.cell, { width: 80 }]}>{jobProfit[job.BU_ID] ? fNum(pNum(jobProfit[job.BU_ID]), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 60 }]}>{jobProfitPerc[job.BU_ID] ? fNum(pNum(jobProfitPerc[job.BU_ID]), 2) + '%' : ''}</Text>
                    {/* <Text style={[s.cell, { width: 80 }]}>{actualOverhead[job.BU_ID] ? fNum(pNum(actualOverhead[job.BU_ID]), 1) : ''}</Text> */}
                    {/* <Text style={[s.cell, { width: 80 }]}>{etcOverhead[job.BU_ID] ? fNum(pNum(etcOverhead[job.BU_ID]), 1) : ''}</Text> */}
                    <Text style={[s.cell, { width: 80 }]}>{grossMargin[job.BU_ID] ? fNum(pNum(grossMargin[job.BU_ID]), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 60, borderRight: '1px solid #d9d9d9' }]}>{grossMarginPerc[job.BU_ID] ? fNum(pNum(grossMarginPerc[job.BU_ID]), 2) + '%' : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 80 }]}>{contingency[job.BU_ID] ? fNum(pNum(contingency[job.BU_ID]), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 80 }]}>{prevContingency[job.BU_ID] ? fNum(pNum(prevContingency[job.BU_ID]), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 80, borderRight: '1px solid #d9d9d9' }]}>{backlog[job.BU_ID] ? fNum(pNum(backlog[job.BU_ID]), 1) : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 40 }]}>{costPercent[job.BU_ID] ? fNum(pNum(costPercent[job.BU_ID]), 1) + '%' : ''}</Text>
                    <Text style={[s.cell, { width: 40 }]}>{actualHours[job.BU_ID] ? fNum(100 * pNum(actualHours[job.BU_ID]) / (pNum(actualHours[job.BU_ID]) + pNum(hoursETC[job.BU_ID])), 1) + '%' : ''}</Text>
                    <Text style={[s.cell, { width: 40, borderRight: '1px solid #d9d9d9' }]}>{physicalComplete[job.BU_ID] ? physicalComplete[job.BU_ID] + '%' : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    {(expandBills || photoLocal) ? <Text style={[s.cell, { width: 80, borderRight: expandBills ? undefined : '1px solid #d9d9d9' }]}>{mostRecentBill[job.BU_ID] != '2021-01-01' ? mostRecentBill[job.BU_ID] : ''}</Text> : null}
                    {expandBills ? <View style={{ flexDirection: 'row' }}>
                        <Text style={[s.cell, { width: 80 }]}>{earnedRevenue[job.BU_ID] ? fNum(pNum(earnedRevenue[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{billings[job.BU_ID] ? fNum(pNum(billings[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 , borderRight: '1px solid #d9d9d9'}]}>{remainingToBill[job.BU_ID] ? fNum(pNum(remainingToBill[job.BU_ID]), 1) : ''}</Text>
                    </View> : null}
                    <Text style={[s.cell, { width: 80, borderRight: '1px solid #d9d9d9' }]}>{overUnderBilled[job.BU_ID] ? fNum(pNum(overUnderBilled[job.BU_ID]), 1) : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 80 }]}>{jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) + pNum(contingency[job.BU_ID]) - pNum(prevContingency[job.BU_ID]), 1) : ''}</Text>
                    {/* <Text style={[s.cell, { width: 80 }]}>{jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobPrevWIP[job.BU_ID]?.total), 1) : ''}</Text>
                <Text style={[s.cell, { width: 80 }]}>{jobPrevWIP[job.BU_ID]?.percent ? fNum(jobPrevWIP[job.BU_ID]?.percent) + '%' : ''}</Text> */}
                    <Text style={[s.cell, { width: 80 }]}>{jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 80, borderRight: '1px solid #d9d9d9' }]}>{jobProfitPerc[job.BU_ID] && jobPrevWIP[job.BU_ID]?.percent ? fNum(pNum(jobProfitPerc[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.percent)) + '%' : ''}</Text>
                    {/* <View style={{ width: 20 }}></View>
                <Text style={[s.cell, { width: 80 }]}>{startDates[job.BU_ID]}</Text>
                <Text style={[s.cell, { width: 80 }]}>{mechCompleteDates[job.BU_ID]}</Text>
                <Text style={[s.cell, { width: 80 }]}>{completionDates[job.BU_ID]}</Text> */}
                </Pressable> : null}
            </View>
        )
    }

    const Header = () => {
        return (
            <View style={{ flexDirection: 'row' }}>
                {photoLocal ? null : <Text style={[s.cellt, { width: 70, backgroundColor: '#e0e0e0' }]}>Job Number</Text>}
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}>Work Type</Text>
                {photoLocal ? null : <Text style={[s.cellt, { width: 110, backgroundColor: '#e0e0e0' }]}>Project Manager</Text>}
                {photoLocal ? <Text style={[s.cellt, { width: 64, backgroundColor: '#e0e0e0' }]}>Job ID</Text> : null}
                <Text style={[s.cellt, { width: 160, backgroundColor: '#e0e0e0' }]}>Job Name</Text>
                {hideProgram ? null : <Text style={[s.cellt, { width: 150, backgroundColor: '#e0e0e0' }]}>Program</Text>}
                <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Client</Text>
                {photoLocal ? null : <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0' }]}>Status</Text>}
                {expandCosts ? <View style={{ flexDirection: 'row' }}>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Actual Cost</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Open Commit</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Labor</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Internal Equipment</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Materials</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Rentals/Fuel</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Subcontractors</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Other</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Contingency</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Incentive</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Total ETC</Text>
                </View> : null}
                <View style={{ width: 5 }}></View>
                <View style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', flexDirection: 'row', alignItems: 'center' }]}>
                    {photoLocal ? null :<Icon3
                        onPress={() => setExpandCosts(!expandCosts)}
                        name={expandCosts ? "MdExpandMore" : "MdChevronRight"}
                        size={20}
                        color="black"
                    />}
                    <Text style={{ fontSize: 10, flexWrap: 'wrap' }}>Cur Budget Revenue</Text>
                </View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Est Cost At Completion</Text>
                {/* <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Actual Cost</Text>
            <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Open Commit</Text>
            <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>ETC</Text> */}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Job Profit</Text>
                <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0' }]}>Job Profit %</Text>
                {/* <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Overhead</Text>
            <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>ETC Overhead</Text> */}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Gross Margin</Text>
                <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0' }]}>Gross Margin %</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Current Contingency</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev WIP Contingency</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Backlog</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}>Costs</Text>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}>Labor Hours</Text>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}>Physical</Text>
                <View style={{ width: 5 }}></View>
                {(expandBills || photoLocal) ? <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', borderRight: expandBills ? undefined : '1px solid #d9d9d9' }]}>Last Billing</Text> : null}
                {expandBills ? <View style={{ flexDirection: 'row' }}>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Earned Revenue</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Billings</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Remaining to Bill</Text>
                </View> : null}
                <View style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', flexDirection: 'row', alignItems: 'center', position: 'relative' }]}>
                    <View style={{ position: 'absolute', top: 0}}>
                        {photoLocal ? null :<Icon3
                            onPress={() => setExpandBills(!expandBills)}
                            name={expandBills ? "MdExpandMore" : "MdChevronRight"}
                            size={20}
                            color="black"
                        />}
                    </View>
                    <Text style={{ fontSize: 10, flexWrap: 'wrap' }}>Over/Under Billed</Text>
                </View>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Job Performance Change</Text>
                {/* <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev Job Profit</Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev Job Profit %</Text> */}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev. WIP Gain/Fade $</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev. WIP Gain/Fade %</Text>
                {/* <View style={{ width: 20 }}></View>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Start Date (Actual)</Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Mechanically Complete Date</Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Completion Date (Forecasted)</Text> */}
            </View>
        )
    }

    const Footer = () => {
        return (
            <View style={{ flexDirection: 'row' }}>
                {photoLocal ? null : <Text style={[s.cellt, { width: 180, backgroundColor: '#e0e0e0' }]}></Text>}
                <Text style={[s.cellt, { width: (hideProgram ? 300 : 450) + (photoLocal ? 64 : 0), backgroundColor: '#e0e0e0' }]}></Text>
                {photoLocal ? null : <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0' }]}></Text>}
                {expandCosts ? <View style={{ flexDirection: 'row' }}>
                    <View style={{ width: 880 }}></View>
                </View> : null}
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalBudget}</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalEAC}</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalJobProfit}</Text>
                <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalJobProfitPercent}</Text>
                {/* <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text> */}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalGrossMargin}</Text>
                <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalGrossMarginPercent}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalContingency}</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalPrevContingency}</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalBacklog}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}></Text>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}></Text>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}></Text>
                <View style={{ width: 5 }}></View>
                {(expandBills || photoLocal) ? <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text> : null}
                {expandBills ? <View style={{ flexDirection: 'row' }}>
                    <View style={{ width: 240 }}></View>
                </View> : null}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalOverUnderBilled}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalJobPerformanceChange}</Text>
                {/* <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalPrevJobProfit}</Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalPrevJobProfitPerc}</Text> */}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0', textAlign: 'right', display: 'block' }]}>{totalPrevWIP}</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text>
                {/* <View style={{ width: 20 }}></View>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text> */}
            </View>
        )
    }

    return (
        <View>
            {/* <View style={{ flexDirection: 'row', justifyContent: 'flex-start', marginRight: 'auto' }}>
                <View style={{ backgroundColor: 'white', borderRadius: 5, margin: 20, flexDirection: 'row', alignItems: 'center', padding: 10 }}>
                    {versionInfo && versionInfo.Version_Start_DateTime &&
                        <View>
                            <View style={{ backgroundColor: isLiveVersion ? '#192440' : 'white', borderRadius: 5, justifyContent: 'center', padding: 10 }}>
                                <Text style={{ color: isLiveVersion ? 'white' : 'black' }}>
                                    {moment(versionInfo.Version_Start_DateTime).format('MMM D, YYYY')} {isLiveVersion ? '- Active' : ''}
                                </Text>
                            </View>
                        </View>
                    }
                    <Text style={{ fontSize: 16, paddingLeft: 30 }}>
                        {selectedTeam}
                    </Text>
                </View>
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={() => {
                            createExcel()
                        }}
                    >
                        <Icon2
                            name="file-download"
                            size={20}
                        />
                    </Pressable>
                </View>
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={() => {
                            setPhotoLocal(!photoLocal)
                        }}
                    >
                        <Text>Collapse Columns For PSR</Text>
                    </Pressable>
                </View>
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={() => {
                            setAdminButton(!adminButton)
                        }}
                    >
                        <Text>Load All Teams</Text>
                    </Pressable>
                </View>
            </View> */}
            <View style={{ margin: 30, borderRadius: 5, backgroundColor: 'white', padding: 20, marginBottom: 20, borderRadius: 6, flexDirection: 'row', shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                {/* <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 0 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: isExporting ? '#f5f5f5' : '#4CAF50', padding: 10, borderRadius: 5, opacity: isExporting ? 0.6 : 1 }}
                        onPress={() => !isExporting && exportToExcel()}
                        disabled={isExporting}
                    >
                        <Text style={{ color: 'white', fontWeight: '500' }}>
                            {isExporting ? 'Exporting...' : 'Export to Template'}
                        </Text>
                    </Pressable>
                </View> */}
                <View ref={view}>
                    {photo && backlogFilteredImage ? backlogFilteredImage.map((summary, i) => (
                        <View ref={sectionRefs.current[i]}>
                            <Header />
                            {summary ? summary.map((job, i) => (
                                <Row key={i} job={job} />
                            )) : null}
                            <Footer />
                        </View>
                    )) :
                        <View ref={sectionRefs.current[0]}>
                            <Header />
                            {backlogFiltered.map((job, i) => (
                                <Row key={i} job={job} />
                            ))}
                            <Footer />
                        </View>
                    }
                </View>
            </View>
            {!photoLocal && <div style={{ margin: '0 30px 200px', borderRadius: 10, backgroundColor: 'white', padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0' }}>
                <AISummary buildPrompt={buildSummaryPrompt} palette={summaryPalette} pageKey={`summary_${selectedTeam || 'all'}`} />
            </div>}
        </View>
    );
}





export default Summary;

